module.exports = __webpack_public_path__ + "img/gold-card.3ec61f49.png";